export default __webpack_public_path__ + "static/media/19.f6cb8c84.jpg";